import { Box, Button, Collapse, Divider, Flex, HStack, Text, VStack } from '@chakra-ui/react'
import { PopUpMessageContext } from '@hb/react'
import { FieldTypes, MessageThread, TextField, ThreadType } from '@hb/shared'
import { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { addUsersToThread, removeUsersFromThread } from '../../../backend/functions/other'
import { StandaloneInput } from '../../forms'
import { SearchUsersList } from '../../Users/SearchUsersList'
import { ThreadMemberView } from '../ThreadMembers/ThreadMemberView'

const requiredThreadTitleField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: 'Thread Title (required for group threads)',
}
export const AddMembersView = ({
  thread,
  threadId,
  height,
  onClose,
  threadType,
  isOpen,
}: {
  thread: MessageThread | null
  threadType: ThreadType
  height: number
  isOpen: boolean
  threadId?: string | null
  onClose: () => void
}) => {
  const [loading, setLoading] = useState(false)
  const [selected, setSelected] = useState<string[]>([])
  // const [accessLevel, setAccessLevel] = useState<UserGroup | null>(null)

  const [title, setTitle] = useState<string>(thread?.title ?? '')
  const titleRequired = useMemo(() => {
    const currThreadSubscribers =
      thread?.subscribers && Array.isArray(thread.subscribers) ? thread.subscribers : []
    const currMembersLength = currThreadSubscribers.length
    const updatedMembersLength = selected.length + currMembersLength
    return updatedMembersLength > 2
  }, [thread, selected])

  useEffect(() => {
    if (thread?.title) {
      setTitle(thread.title)
    }
  }, [thread?.title])

  const { processResponse } = useContext(PopUpMessageContext)
  const handleAddMembers = useCallback(async () => {
    if (!selected.length) return
    if (!threadId) return
    if (!title && titleRequired) {
      processResponse({ error: 'Title is required for group threads' })
      return
    }
    setLoading(true)
    try {
      await addUsersToThread({
        threadId,
        userIds: selected,
        type: threadType,
        title: title ?? '',
      })
      onClose()
    } catch (e: any) {
      console.error(e)
    }
    setLoading(false)
  }, [onClose, threadId, selected, threadType, titleRequired, title, processResponse])

  useEffect(() => {
    if (!isOpen) setSelected([])
  }, [isOpen])

  // const { appName } = useApp()
  // const accessLevelField = useMemo(
  //   () => (appName === 'providers-app'
  //     ? practiceAccessLevelField
  //     : adminAccessLevelField),
  //   [appName],
  // )

  return (
    <VStack bg="gray.100" spacing={0} height={`${height}px`} width="100%">
      {/* <HStack w="100%">
        <Text
          fontFamily="Open Sans"
          fontSize="md"
          fontWeight={600}
          color="gray.600"
        >
          User Group
        </Text>
        <Box flex={1}>
          <StandaloneInput
            theme="detailed"
            style={{ padding: '0.5rem 0.5rem' }}
            field={accessLevelField}
            value={accessLevel || thread?.accessLevel}
            onChange={setAccessLevel}
          />
        </Box>
      </HStack> */}
      <Flex flex={1} w="100%" overflowY="auto" flexFlow="column">
        <VStack py={2} px={3} bg="blackAlpha.100" spacing={1} w="100%" align="flex-start">
          <Text fontFamily="Hero-New" color="gray.500" fontSize="sm">
            Current Members
          </Text>
          <VStack w="100%" spacing={1} align="flex-start">
            {thread?.subscribers?.length ? (
              thread.subscribers.map(sub => (
                <ThreadMemberView
                  onDelete={async () => {
                    if (!threadId) return
                    await removeUsersFromThread({
                      threadId,
                      type: threadType,
                      userIds: [sub],
                    })
                  }}
                  key={sub}
                  userId={sub}
                />
              ))
            ) : (
              <Text>No members</Text>
            )}
          </VStack>
        </VStack>
        <Divider />
        <Box px={2} py={3}>
          <SearchUsersList
            selected={selected}
            existing={
              thread?.subscribers && Array.isArray(thread?.subscribers) ? thread?.subscribers : []
            }
            excludeMe
            onChange={setSelected}
            group={thread?.accessLevel}
            label="Add Members"
            type="user"
          />
          <Box w="100%">
            <Collapse style={{ width: '100%' }} in={titleRequired}>
              <Box w="100%" px={2} pt={3} pb={1}>
                <StandaloneInput
                  theme="detailed"
                  field={requiredThreadTitleField}
                  value={title}
                  onChange={setTitle}
                />
              </Box>
            </Collapse>
          </Box>
        </Box>
      </Flex>
      <Divider />
      <HStack p={2} w="100%">
        <Button bg="white" border="1px solid #cdcdcd" size="sm" flex={1} onClick={onClose}>
          <Text>Cancel</Text>
        </Button>
        <Button
          size="sm"
          flex={1}
          colorScheme="green"
          opacity={selected.length ? 1 : 0.5}
          onClick={handleAddMembers}
          isLoading={loading}>
          Submit
        </Button>
      </HStack>
    </VStack>
  )
}
